import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import groups from 'modules/reviews/store/collections/groups'

export function useGroups(): {
  loading: boolean
} {
  const { loading } = useAsyncData(async () => {
    await groups.fetch()
  }, [])

  return { loading }
}
